export type FlowSlot =
    | 'name'
    | 'usage'
    | 'readingDate'
    | 'readingScopeInfo'
    | 'readingShape'
    | 'meterTypes'
    | 'systems'
    | 'format'
    | 'columns'
    | 'preview'
    | 'schedule';

const closingSlots = ['columns', 'format', 'preview', 'schedule'] as const;

export type ClosingSlot = (typeof closingSlots)[number];

export function flowSlots<T extends Exclude<FlowSlot, ClosingSlot>>(
    openingSlots: ReadonlyArray<T>,
    {without = []}: {without?: ReadonlyArray<ClosingSlot>} = {},
): ReadonlyArray<T | ClosingSlot> {
    return [...openingSlots, ...closingSlots.filter(slot => !without.includes(slot))];
}

const attachedSlots: ReadonlyArray<FlowSlot> = ['preview'];

export function stepGroups<T extends {id: FlowSlot}>(
    steps: ReadonlyArray<T>,
): ReadonlyArray<ReadonlyArray<T>> {
    return steps.reduce<T[][]>((groups, step) => {
        const lastGroup = groups.at(-1);
        if (lastGroup !== undefined && attachedSlots.includes(step.id)) {
            lastGroup.push(step);
        } else {
            groups.push([step]);
        }
        return groups;
    }, []);
}
